<template>
    <DxValidationGroup ref="formValidation">
        <div class="row mb-4">
            <div class="xs12">
                <DxDateBox
                    label="Ngày lọc (*)"
                    v-model="LocBaoCao.TuNgay"
                    displayFormat="dd/MM/yyyy"
                    :use-mask-behavior="true"
                    dropDownButtonTemplate="customIcon"
                    validationMessageMode="always"
                    styling-mode="outlined"
                >
                    <DxValidator ref="validate">
                        <DxRequiredRule message="Vui lòng chọn ngày!" />
                        <DxRangeRule
                            :max="MaxDate"
                            :message="$i18n.t('DefaultString.MaxDate')"
                        />
                        <DxRangeRule
                            :min="MinDate"
                            :message="$i18n.t('DefaultString.MinDate')"
                        />
                        <!-- <DxRangeRule
                            :max="LocBaoCao.DenNgay"
                            message="Từ ngày phải nhỏ hơn đến ngày!"
                        />
                        <DxCustomRule
                            :validationCallback="check31Day"
                            message="Không được vượt quá 31 ngày!"
                        /> -->
                    </DxValidator>
                    <template #customIcon="{}">
                        <DxButton icon="mdi mdi-calendar" />
                    </template>
                </DxDateBox>
            </div>
        </div>

        <!-- <div class="row mb-4">
            <div class="xs12">
                <DxDateBox
                    label="Đến ngày (*)"
                    v-model="LocBaoCao.DenNgay"
                    displayFormat="dd/MM/yyyy"
                    :use-mask-behavior="true"
                    dropDownButtonTemplate="customIcon"
                    validationMessageMode="always"
                    styling-mode="outlined"
                >
                    <DxValidator ref="validate">
                        <DxRequiredRule message="Vui lòng chọn ngày!" />
                        <DxRangeRule
                            :max="MaxDate"
                            :message="$i18n.t('DefaultString.MaxDate')"
                        />
                        <DxRangeRule
                            :min="MinDate"
                            :message="$i18n.t('DefaultString.MinDate')"
                        />
                        <DxRangeRule
                            :min="LocBaoCao.TuNgay"
                            message="Đến ngày phải lớn hơn từ ngày!"
                        />
                        <DxCustomRule
                            :validationCallback="check31Day"
                            message="Không được vượt quá 31 ngày!"
                        />
                    </DxValidator>
                    <template #customIcon="{}">
                        <DxButton icon="mdi mdi-calendar" />
                    </template>
                </DxDateBox>
            </div>
        </div>

        <div class="row mb-4">
            <div class="xs12">
                <DxSelectBox
                    label="Trạng thái (*)"
                    labelMode="floating"
                    v-model="LocBaoCao.TrangThai"
                    :dataSource="DanhSachTrangThai"
                    displayExpr="text"
                    valueExpr="value"
                    styling-mode="outlined"
                    validationMessageMode="always"
                >
                    <DxValidator>
                        <DxRequiredRule message="Không được bỏ trống!" />
                    </DxValidator>
                </DxSelectBox>
            </div>
        </div> -->
    </DxValidationGroup>

    <div class="row justify-space-between">
        <DxButton
            text="Hủy"
            type="default"
            styling-mode="text"
            @click="hiddenPopup"
        />
        <DxButton
            text="Tìm kiếm"
            type="default"
            styling-mode="contained"
            @click="LayDanhSachVe()"
        />
    </div>
</template>

<script>
import {
    DxRequiredRule,
    DxRangeRule,
    DxCustomRule,
} from "devextreme-vue/data-grid";
import {
    DxDateBox,
    DxValidationGroup,
    DxValidator,
    DxButton,
    DxSelectBox,
} from "devextreme-vue";

export default {
    components: {
        DxValidationGroup,
        DxDateBox,
        DxButton,
        DxSelectBox,
        DxValidator,
        DxRequiredRule,
        DxRangeRule,
        DxCustomRule,
    },
    data() {
        return {
            MaxDate: new Date(this.$i18n.t("DefaultNumBer.MaxDate")),
            MinDate: new Date(this.$i18n.t("DefaultNumBer.MinDate")),
            DanhSachTrangThai: [
                {
                    text: "Tất cả",
                    value: "all",
                },
                {
                    text: "Đã phát hành",
                    value: "true",
                },
                {
                    text: "Chưa phát hành",
                    value: "false",
                },
            ],
        };
    },
    computed: {
        LocBaoCao: {
            get() {
                return this.$store.state.BaoCao.LocBaoCao;
            },
            set(data) {
                this.$store.commit("BaoCao/Set", {
                    key: "LocBaoCao",
                    data: data,
                });
            },
        },
    },
    watch: {},
    methods: {
        hiddenPopup() {
            this.$emit("hiddenPopup", "PopupLocDuLieu");
        },
        LayDanhSachVe() {
            let validate = this.$refs.formValidation.instance.validate();
            if (!validate.isValid) {
                return this.$Helper.Common.autoFocusError(validate);
            }
            this.emitter.emit("LayDanhSachVe");
            this.hiddenPopup();
        },
        check31Day() {
            let startDay = this.LocBaoCao.TuNgay;
            let endDay = this.LocBaoCao.DenNgay;
            let soNgay = (endDay - startDay) / 1000 / 60 / 60 / 24;
            return soNgay < 31;
        },
    },
    created() {
        this.LocBaoCao.TuNgay = this.$Helper.Common.getStartDay(
            this.LocBaoCao.TuNgay
        );
        this.LocBaoCao.DenNgay = this.$Helper.Common.getEndDay(
            this.LocBaoCao.DenNgay
        );
    },
    mounted() {},
};
</script>

<style scoped></style>
